import React from 'react';
import { IconButton, Stack, Tooltip, useTheme } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SaveIcon from '@mui/icons-material/Save';
import EmailIcon from '@mui/icons-material/Email';
import DraftsIcon from '@mui/icons-material/Drafts';

import { useAskAIContext } from '@/context/AskAiContext';

const MessageActions = ({ message }) => {
	const {
		isBusy: disabled,
		handleComposeEmail,
		handleGenerateEmailDraft,
		handleCopy,
		handleCreateTask,
		handleSaveWorkspace,
		handleCreateNote,
	} = useAskAIContext();
	const theme = useTheme();

	const ACTION_SX = {
		width: 32,
		height: 32,
		color: theme.palette.text.secondary,
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
			color: theme.palette.text.primary,
		},
	};

	return (
		<Stack direction='row' spacing={0.15} flexWrap='wrap' useFlexGap alignItems='center'>
			<Tooltip title='Copy'>
				<span>
					<IconButton
						size='small'
						onClick={() => handleCopy(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<ContentCopyIcon sx={{ fontSize: 17 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title='Create note'>
				<span>
					<IconButton
						size='small'
						onClick={() => handleCreateNote(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<NoteAddIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title={'Save workspace'}>
				<span>
					<IconButton
						size='small'
						onClick={() => handleSaveWorkspace(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<SaveIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title='Create task'>
				<span>
					<IconButton
						size='small'
						onClick={() => handleCreateTask(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<AssignmentTurnedInIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title='Send as email'>
				<span>
					<IconButton
						size='small'
						onClick={() => handleComposeEmail(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<EmailIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title='Generate email draft'>
				<span>
					<IconButton
						size='small'
						onClick={() => handleGenerateEmailDraft(message)}
						disabled={disabled}
						sx={ACTION_SX}
					>
						<DraftsIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
		</Stack>
	);
};

export default MessageActions;
